/** Shared slug helpers for cuisine and dietary landing pages. */
export function slugifyTaxon(name: string): string {
  return name
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/** Finds the canonical taxonomy name matching a slug, or null. */
export function findByTaxonSlug(names: string[], slug: string): string | null {
  const s = slug.toLowerCase();
  return names.find((n) => slugifyTaxon(n) === s) ?? null;
}
